<template>
  <div
    v-loading.fullscreen.lock="loading"
    class="goods_detail"
    ref="goodDetail"
  >
    <!-- 头部 -->
    <top-part :rightPart="true"></top-part>
    <!-- 头部 结束 -->
    <div v-if="currentList">
      <div class="goods_ctn ctn_top">
        <!-- 商品图片 -->
        <div class="goods_imgs" v-if="imgList && imgList.length > 0">
          <van-swipe @change="onChange">
            <van-swipe-item v-for="(item, index) in imgList" :key="index">
              <img :src="item.imageUrlSrc" />
              <!-- <img src="@/images/goods1.png" /> -->
            </van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                {{ current + 1 }}/{{ imgList.length }}
              </div>
            </template>
          </van-swipe>
        </div>
        <!-- 商品图片 结束-->
        <div class="exchange_time" v-if="timeDuring">
          兑奖时间：{{ timeDuring }}
        </div>
        <!-- 兑换说明 -->
        <div class="goods_intro">
          <div>
            <div class="intro_title">{{ productName }}</div>
            <div class="intro_ctn">
              <div>兑换说明</div>
              <p>{{ exNote }}</p>
              <span>{{ shippingNote }}</span>
            </div>
          </div>
        </div>
        <!-- 兑换说明 结束-->
        <!-- 商品详情 -->
        <div class="detail_ctn">
          <p class="ctn_desc">
            ———&nbsp;&nbsp;&nbsp;&nbsp;商品详情&nbsp;&nbsp;&nbsp;&nbsp;———
          </p>
          <div></div>
        </div>
        <!-- 商品详情 结束 -->
        <div v-html="productDetails" class="product_detail"></div>
      </div>

      <!-- 底部按钮 -->
      <div class="goods_footer" v-if="!disabled">
        <!-- 1 可兑换  0 已兑换 exchangeStatus-->
        <div v-if="exchangeStatus == 0" @click="toComfirm">
          已兑换,去签名
        </div>
        <div
          v-else
          :class="welfareInfo.welfareState != '1' ? 'btn_disabled' : ''"
          @click="toComfirm"
        >
          {{ btnObj[welfareInfo.welfareState] }}
        </div>
      </div>
    </div>

    <!-- 没数据时 -->
    <div class="blank" v-else>
      <img src="@/images/404-02.png" alt />
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  components: {
    topPart,
  },
  data() {
    return {
      loading: true,
      current: 0,
      imgList: [], //商品图片
      productName: "", //商品name
      productDetails: "", //商品详情
      timeDuring: "",
      currentList: {},
      welfareInfo: {},
      btnObj: {
        0: "兑换未开始",
        1: "立即兑换",
        2: "兑换已结束",
      },
      shippingNote: "", //配送方式
      exNote: "", //兑换说明
      disabled: this.$route.query.disabled,
      exchangeStatus: 0, //是否已兑换
      category: "",
      orderId: "",
    };
  },
  mounted() {
    this.category = this.$route.query.welfareCategory;
    this.queryDetail();
    this.$refs.goodDetail.scrollTop = 0;
  },
  methods: {
    // 获取商品详情
    queryDetail() {
      const { id, welfareId, welfareCategory } = this.$route.query;
      let params = {
        id,
        welfareId,
        welfareCategory: welfareCategory,
      };
      this.centralControl.axios.centralControl(
        "listProduct",
        (res) => {
          this.loading = false;
          const { code, message, data } = res;
          if (code == 200) {
            const { list, total } = data;
            let currentList = list && list[0];
            this.currentList = currentList;
            if (!currentList) return;
            const {
              images,
              productName,
              productDetails,
              welfareInfo,
              shippingNote,
              exNote,
              exchangeStatus,
              orderId,
            } = currentList;
            this.imgList = JSON.parse(images);
            this.productName = productName;
            this.productDetails = productDetails;
            this.welfareInfo = welfareInfo;
            this.shippingNote = shippingNote;
            this.exNote = exNote;
            this.exchangeStatus = exchangeStatus;
            this.orderId = orderId || "";
            if (welfareInfo.startTime && welfareInfo.finishTime) {
              this.timeDuring =
                this.formatDate(welfareInfo.startTime) +
                " 至 " +
                this.formatDate(welfareInfo.finishTime);
            }
            //   res.data.content = res.data.content
            // .replace(new RegExp("&lt;", "g"), "<")
            // .replace(new RegExp("&quot;", "g"), "")
            // .replace(new RegExp("&gt;", "g"), ">");
          } else {
            toast(this, message, "error");
          }
        },
        params
      );
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // 滑动图片事件
    onChange(index) {
      this.current = index;
    },
    //跳转- 确认订单
    toComfirm() {
      const { welfareCategory } = this.$route.query;
      // 进行中才可跳转
      if (this.welfareInfo.welfareState != "1" || this.exchangeStatus == 0) {
        this.$router.push({
          path: "exchangeDetail",
          query: {
            id: this.orderId,
            detailsType: welfareCategory,
          },
        });
      } else {
        this.$router.push({
          path: "orderConfrim",
          query: {
            id: this.currentList.id,
            welfareId: this.welfareInfo.id,
            welfareState: this.welfareInfo.welfareState,
            welfareCategory: this.category,
          },
        });
      }
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common';

.goods_detail {
  height: 100%;
  overflow: auto;

  .van-swipe {
    height: 100%;
  }

  .van-swipe-item {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 50%;
      height: 90%;
    }
  }

  .custom-indicator {
    width: 32px;
    height: 18px;
    line-height: 18px;
    background: rgba(0, 0, 0, 1);
    border-radius: 13px;
    opacity: 0.5;
    font-size: 10px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    padding: 0px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }

  .goods_ctn {
    background: #FFF;
    padding-bottom: 66px;

    .goods_imgs {
      height: 190px;
      width: 100%;
    }

    .exchange_time {
      // width: 100%;
      background: rgba(255, 75, 75, 0.1);
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: rgba(255, 75, 75, 1);
      line-height: 20px;
      padding: 9px 16px;
    }

    .goods_intro {
      padding: 0 16px;

      .intro_title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(53, 53, 53, 1);
        padding: 16px 0;
      }

      .intro_ctn {
        background: rgba(244, 245, 249, 1);
        border-radius: 8px;
        padding: 16px;
        position: relative;

        >div {
          width: 88px;
          height: 22px;
          background: url('../../assets/images/intro_back.png') no-repeat center center;
          background-size: 88px 22px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;
          text-align: center;
          position: absolute;
          top: 10px;
          left: -8px;
        }

        >p {
          margin-top: 28px;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(53, 53, 53, 1);
          line-height: 20px;
          margin-bottom: 10px;
        }

        >span {
          color: #FF4B4B;
        }
      }
    }

    .detail_ctn {
      .ctn_desc {
        font-size: 13px;
        text-align: center;
        color: rgba(202, 202, 210, 1);
        line-height: 50px;
      }
    }
  }

  .goods_footer {
    position: fixed !important;
    width: 100%;
    left: 0px;
    bottom: 0px;
    height: 66px;
    background: #FFF;

    div {
      margin: 11px 16px;
      background: #5188FC;
      border-radius: 5px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      // font-weight:600;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      height: 44px;
    }

    .btn_disabled {
      background: rgba(202, 202, 210, 1);
    }
  }

  .product_detail {
    padding: 0 10px 10px 10px;

    img {
      max-width: 100%;
    }

    p, span {
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>